<mat-card>
  <div class="header">提交表单</div>

  <div class="content">
    <div class="item">
      <app-select
        label="产品"
        [data]="platformData"
        [formControl]="platform"
      ></app-select>
      <app-select
        label="车次"
        [data]="busData"
        [formControl]="bus"
      ></app-select>
    </div>
    <div class="item">
      <div class="input-radio">
        <app-input label="如何称呼您" [formControl]="name"></app-input>
        <app-sex-radio-button
          [(ngModel)]="sex"
          (valueChange)="onChange($event)"
        ></app-sex-radio-button>
      </div>
      <app-select
        label="希望何时联系您"
        [data]="timeData"
        [formControl]="time"
      ></app-select>
    </div>
    <div class="item">
      <app-select
        label="账号是否实时验证"
        [data]="whetherData"
        [formControl]="whether"
      ></app-select>
      <app-input
        label="联系方式"
        placeholder="手机号或者微信号"
        [formControl]="tel"
      ></app-input>
    </div>
    <div class="item">
      <app-input
        label="充值账号"
        placeholder="充值的账户"
        [formControl]="account"
      ></app-input>
      <app-input
        label="账号密码"
        placeholder="账户的密码"
        [formControl]="password"
      ></app-input>
    </div>
    <div class="tip">
      <span style="color: #e00000">注：</span>
      充值服务会1对1进行，专员在线时间为<span style="color: #009688">
        早10:00 — 晚7:00
      </span>
      若未及时处，也可主动留言。
    </div>
    <div class="button">
      <button mat-flat-button (click)="submit()" [disabled]="submitLoading">
        提交
      </button>
    </div>
    <div class="qrcode">
      扫描二维码<img
        src="../../../../assets/images/form-qrcode.png"
        width="108"
        height="108"
        alt=""
      />
    </div>
  </div>
  <app-global-loading *ngIf="loading"></app-global-loading>
</mat-card>
